import { forwardRef, type ReactNode } from 'react'

import { ACCEPTED_FILE_TYPES } from './chat-input-composer.config'

interface ChatInputHiddenFileProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

/**
 * Hidden file input for attachment selection.
 */
export const ChatInputHiddenFile = forwardRef<HTMLInputElement, ChatInputHiddenFileProps>(
  ({ onChange }, ref): ReactNode => (
    <input
      ref={ref}
      type="file"
      accept={ACCEPTED_FILE_TYPES}
      multiple
      onChange={onChange}
      className="sr-only"
      tabIndex={-1}
    />
  )
)

ChatInputHiddenFile.displayName = 'ChatInputHiddenFile'
